import { Table } from 'antd';
import React from 'react';

export default function RefsLinksTable({ onRowClick, items }) {
  const columns = [
    {
      title: 'Код',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Наименование',
      dataIndex: 'title',
      key: 'title',
    },
  ];
  return (
    <Table
      columns={columns}
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      dataSource={items}
    />
  );
}
